import { forwardRef, InputHTMLAttributes } from 'react';

import { classNames } from '@/utils/classnames';

export const Radio = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  (props, ref) => {
    const { className, ...rest } = props;

    return (
      <input
        ref={ref}
        className={classNames(
          'border-token-gray-700',
          'bg-transparent',
          'rounded-xlarge',
          'grid',
          'place-content-center',
          'appearance-none',
          '[-webkit-appearance:none]',
          '[-moz-appearance:none]',
          'focus-visible:shadow-[0px_0px_0px_4px_var(--color-token-gray-300)]',
          'focus-visible:outline-none',
          'hover:cursor-pointer',
          'hover:border-token-gray-800',
          'disabled:border-token-gray-700',
          'checked:bg-token-purple-900',
          'checked:border-transparent',
          'checked:disabled:bg-token-purple-900',
          'checked:disabled:border-transparent',
          'checked:disabled:hover:bg-token-gray-700',
          'checked:disabled:hover:border-transparent',
          'checked:hover:bg-token-purple-1000',
          'checked:focus-visible:bg-token-purple-1000',
          'checked:disabled:focus-visible:bg-token-gray-700',
          'checked:disabled:focus-visible:border-transparent',
          'before:content-[""]',
          'before:w-[0.65em]',
          'before:h-[0.65em]',
          'before:rounded-full',
          'before:transform-[scale(0)]',
          'before:duration-120',
          'before:transition-transform',
          'before:ease-in-out',
          'before:shadow-[inset_1em_1em_var(--color-special-content-button-purple)]',
          'checked:before:transform-[scale(1)]',
          'checked:before:shadow-[inset_1em_1em_var(--color-special-content-button-purple)]',
          'checked:disabled:before:transform-[scale(1)]',
          'checked:disabled:before:shadow-[inset_1em_1em_var(--color-special-content-button-purple)]',
          'checked:disabled:before:transform-[scale(1)]',
          'checked:disabled:before:shadow-[inset_1em_1em_var(--color-token-gray-400)]',
          className,
        )}
        type="radio"
        {...rest}
      />
    );
  },
);

Radio.displayName = 'Radio';
